import { patchdata } from 'apis/PatchData';
import { handle420 } from 'apis/HandleError';
import { apiConfig } from 'config';

const STATUS_CHECK_INTERVAL_MS = 2000;

const checkResponse = (url, data, resolve, reject) => {
  const auth = window.__APP_AUTH;
  const headers = {
    Accept: '*/*',
    'cache-control': 'no-cache',
    Authorization: 'Bearer ' + auth?.accessToken,
    'accept-encoding': 'gzip, deflate'
  };

  if (data == null) {
    fetch(url, { headers: headers, method: 'GET' })
      .then((result) => {
        result.json().then((jsonData) => checkResponse(url, jsonData, resolve, reject));
      })
      .catch((error) => console.log(error));
    return;
  }
  console.log(data.runtimeStatus);
  if (data.runtimeStatus !== 'Pending' && data.runtimeStatus !== 'Running') {
    //TODO perform an action
    //console.log("DONE! Data:", data);
    resolve(data);
    return;
  }

  setTimeout(function () {
    fetch(url, { headers: headers, method: 'GET' }).then((result) => {
      result.json().then((jsonData) => {
        checkResponse(url, jsonData, resolve, reject);
      });
    });
  }, STATUS_CHECK_INTERVAL_MS);
};

export function patchDevice(id, parameters, retry = true) {
  let promise = new Promise((resolve, reject) => {
    let url = apiConfig.cmServiceDevices(id);
    patchdata(url, parameters)
      .then((response) => {
        if (response.status === 200) {
          //offline device
          response.isOfflineDevice = true;
          resolve(response); //response.json();
        } else if (response.status === 202) {
          response.json().then((data) => {
            //reject();
            console.log('Patch response:', data);
            let url = data.statusQueryGetUri; //data.statusQueryGetUri.substring(data.statusQueryGetUri.search("/runtime/webhooks/durabletask/instances"));
            //console.log("url:", url);
            checkResponse(url, null, resolve, reject);
          });
        }
      })
      .catch((e) => {
        console.log('fetch data error = ' + e.message);
        switch (e.message) {
          case '420':
            const auth = window.__APP_AUTH;
            if (auth && retry) {
              return auth.renewSession().then(() => {
                return patchDevice(id, parameters, (retry = false));
              });
            } else {
              handle420();
            }
            break;
          default:
            reject(e);
        }
        return;
      });
  });
  return promise;
}
